module.exports = __webpack_public_path__ + "img/heart_17_bj.e61be0d2.png";